export { default } from './LinkOrNativeAnchor';
